import { Controller } from 'react-hook-form';
import Input from '../ui/Input';
import DatePicker from '../ui/DatePicker';
import FormSection from '../ui/FormSection';

export default function CEUBasicInfo({ control, errors }) {
  return (
    <FormSection
      title="Basic Information"
      description="Enter the workshop details, instructor, and provider information"
    >
      <div className="space-y-4">
        <Controller
          name="workshopName"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              label="Workshop/Course Title *"
              error={errors.workshopName?.message}
              placeholder="e.g., Legal Interpreting Workshop"
            />
          )}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Controller
            name="instructor"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Instructor Name *"
                error={errors.instructor?.message}
                placeholder="e.g., Dr. Jane Smith"
              />
            )}
          />

          <Controller
            name="provider"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Provider/Organization"
                placeholder="e.g., State Court System, RID"
              />
            )}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Controller
            name="date"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                label="Date *"
                error={errors.date?.message}
              />
            )}
          />

          <Controller
            name="ceuHours"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="CEUs *"
                type="number"
                step="0.1"
                min="0"
                error={errors.ceuHours?.message}
                placeholder="2.0"
              />
            )}
          />
        </div>
      </div>
    </FormSection>
  );
}
